// Libs
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

// Component
import PaymentStatusModal from 'hfty-checkout/src/components/PaymentStatusModal'

const mapDispatchToProps = {
  push,
}

export default connect(null, mapDispatchToProps)(PaymentStatusModal)
